<template>
  <div>
    <div class="flex flex-col">
      <div class="mb-2 ">
        <div>
          <b class="sm:text-xs sm:font-normal">1部屋ご利用人数</b><span class="ml-2 px-1 required sm:hidden">必須</span>
        </div>
        <div class="sm:hidden">
          <span>部屋ごとの人数内訳は次の画面でご選択いただけます。</span>
        </div>
      </div>
      <!-- 会員（2親等以内） -->
      <div class="flex items-center gap-x-4">
        <div class="w-1/2 flex items-center justify-start gap-x-4 sm:gap-x-2 sm:w-auto">
          <div class="subitem hidden sm:block"></div>
          <label class="whitespace-nowrap">大人</label>
          <!-- <a-input class="w-20"/> -->
          <!-- <Stepper class="w-28"/> -->
          <select v-model="memberAdults" class="sp-select">
            <template v-for="(el, index) in peopleOptions">
              <option :value="el.value" :key="`people-${index}`">{{ el.label }}人</option>
            </template>
          </select>

          <a-select v-model="memberAdults" class="w-20 sm:hidden">
            <!-- <Icon name="arrow_pull_up" /> -->
            <a-select-option
              :value="el.value"
              v-for="(el, index) in peopleOptions"
              :key="`people-${index}`"
            >
              {{ el.label }}
            </a-select-option>
          </a-select>
          <span class="-ml-2 sm:hidden">名</span>
        </div>
        <div class="w-1/2 flex items-center justify-start gap-x-4 sm:gap-x-2">
          <label class="whitespace-nowrap">/子ども</label>
          <a-popover
            v-model="showMemberChildren"
            placement="bottom"
            trigger="click"
            class="children-attach"
          >
            <div class="flex">
              <a-input
                class="coupon-plan-people-tpl-input sp-input"
                :value="`${totalChldMemberCnt}${isMobile() ? '人' : ''}`"
                @keypress="
                  ($event) => {
                    $event.preventDefault()
                    return false
                  }
                "
                style="background-color: #fff; color: inherit; cursor: pointer"
              />
              <span class="self-center ml-2 sm:hidden">名</span>
            </div>
            <div slot="content" class="popover-custom-content">
              <div class="popover-block-first">
                <div class="block-first-title">小学生</div>
                <div class="block-first-content">
                  <div class="set-value-group">
                    <div class="set-value-name">高学年</div>
                    <Stepper
                      v-model="memberChldDetails.childrenType10"
                      unit="人"
                      :max="maxChldDiv10"
                      class="w-20"
                      :disabled="!chldDivEnabled.memberType10"
                    />
                  </div>
                  <div class="set-value-group">
                    <div class="set-value-name">低学年</div>
                    <Stepper
                      v-model="memberChldDetails.childrenType15"
                      unit="人"
                      :max="maxChldDiv15"
                      :disabled="!chldDivEnabled.memberType15"
                    />
                  </div>
                </div>
              </div>
              <div class="popover-block-second">
                <div class="block-second-title">幼児</div>
                <div class="block-second-content">
                  <div class="set-value-group">
                    <div class="set-value-name">食事・布団付</div>
                    <Stepper
                      v-model="memberChldDetails.childrenType20"
                      unit="人"
                      :max="maxChldDiv20"
                      :disabled="!chldDivEnabled.memberType20"
                    />
                  </div>
                  <div class="set-value-group">
                    <div class="set-value-name">食事のみ</div>
                    <Stepper
                      v-model="memberChldDetails.childrenType30"
                      unit="人"
                      :max="maxChldDiv30"
                      :disabled="!chldDivEnabled.memberType30"
                    />
                  </div>
                </div>
              </div>
              <div class="popover-block-three">
                <div class="block-three-content">
                  <div class="set-value-group">
                    <div class="set-value-name">布団のみ</div>
                    <Stepper
                      v-model="memberChldDetails.childrenType40"
                      unit="人"
                      :max="maxChldDiv40"
                      :disabled="!chldDivEnabled.memberType40"
                    />
                  </div>
                  <div class="set-value-group">
                    <div class="set-value-name">食事・布団不要</div>
                    <Stepper
                      v-model="memberChldDetails.childrenType50"
                      unit="人"
                      :max="maxChldDiv50"
                      :disabled="!chldDivEnabled.memberType50"
                    />
                  </div>
                </div>
              </div>
            </div>
          </a-popover>
        </div>
      </div>
      <!-- ビジター -->
      <div class="flex items-center gap-x-4 hidden">
        <div class="w-1/2 flex items-center justify-between">
          <label class="whitespace-nowrap">大人</label>
          <!-- <a-input class="w-20"/> -->
          <!-- <Stepper class="w-28"/> -->
          <a-select v-model="visitorAdults" class="w-20">
            <!-- <Icon name="arrow_pull_up" /> -->
            <a-select-option
              :value="el.value"
              v-for="(el, index) in peopleOptions"
              :key="`people-${index}`"
            >
              {{ el.label }}
            </a-select-option>
          </a-select>
        </div>
        <div class="w-1/2 flex items-center justify-between">
          <label class="whitespace-nowrap">子ども</label>
          <a-popover
            v-model="showVisitorChildren"
            placement="bottom"
            trigger="click"
            class="children-attach"
          >
            <div class="flex">
              <a-input
                class="input-value-children w-20"
                v-model="totalChldVisitorCnt"
                @keypress="
                  ($event) => {
                    $event.preventDefault()
                    return false
                  }
                "
                style="background-color: #fff; color: inherit; cursor: pointer"
              />
              <span class="self-center ml-2">名</span>
            </div>
            <div slot="content" class="popover-custom-content">
              <div class="popover-block-first">
                <div class="block-first-title">小学生</div>
                <div class="block-first-content">
                  <div class="set-value-group">
                    <div class="set-value-name">高学年</div>
                    <Stepper
                      v-model="visitorChldDetails.childrenType10"
                      unit="人"
                      max="99"
                    />
                  </div>
                  <div class="set-value-group">
                    <div class="set-value-name">低学年</div>
                    <Stepper
                      v-model="visitorChldDetails.childrenType15"
                      unit="人"
                      max="99"
                    />
                  </div>
                </div>
              </div>
              <div class="popover-block-second">
                <div class="block-second-title">幼児</div>
                <div class="block-second-content">
                  <div class="set-value-group">
                    <div class="set-value-name">食事・布団付</div>
                    <Stepper
                      v-model="visitorChldDetails.childrenType20"
                      unit="人"
                      max="99"
                    />
                  </div>
                  <div class="set-value-group">
                    <div class="set-value-name">食事のみ</div>
                    <Stepper
                      v-model="visitorChldDetails.childrenType30"
                      unit="人"
                      max="99"
                    />
                  </div>
                </div>
              </div>
              <div class="popover-block-three">
                <div class="block-three-content">
                  <div class="set-value-group">
                    <div class="set-value-name">布団のみ</div>
                    <Stepper
                      v-model="visitorChldDetails.childrenType40"
                      unit="人"
                      max="99"
                    />
                  </div>
                  <div class="set-value-group">
                    <div class="set-value-name">食事・布団不要</div>
                    <Stepper
                      v-model="visitorChldDetails.childrenType50"
                      unit="人"
                      max="99"
                    />
                  </div>
                </div>
              </div>
            </div>
          </a-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import _ from 'lodash'
import moment from 'moment'
import func_utils from '@/mixins/func_utils'
import plan_utils from '@/mixins/plan_utils'
import { PLAN_BASE_ON_PRICE } from '@/constants/plan'

export default {
  name: 'PeoplePlan',
  mixins: [func_utils, plan_utils],
  props: [
    'planData',
    'stayDay',
    'stayNights',
    'stayRooms',
    'vacancyCalendar',
    'peopleDetails',
    'source',
    'acptDtlNo'
  ],
  data() {
    return {
      SOURCE_AVAILABLE: {
        plan_detail: 'plan_detail',
        order_confirmation: 'order_confirmation'
      },
      dateFormat: 'YYYY/MM/DD',
      datetimeFormat: 'YYYY-MM-DD HH:mm:ss',
      planDetail: null,
      memberAdults: 1,
      visitorAdults: 0,

      maxStayCapacity: null,
      minStayCapacity: null,
      limitRooms: 0,
      outstockDayMap: {},
      selectedDaysInfo: [],
      showMemberChildren: false,
      showVisitorChildren: false,
      checkConditionBookRoom: false,
      memberChldDetails: {
        childrenType10: 0,
        childrenType15: 0,
        childrenType20: 0,
        childrenType30: 0,
        childrenType40: 0,
        childrenType50: 0
      },
      visitorChldDetails: {
        childrenType10: 0,
        childrenType15: 0,
        childrenType20: 0,
        childrenType30: 0,
        childrenType40: 0,
        childrenType50: 0
      },
      stateChildInfos: [],
      stateVacancyCalendars: [],
    }
  },
  mounted() {
    if (this.planData) {
      this.planDetail = _.cloneDeep(this.planData)
      this.maxStayCapacity = _.get(this.planDetail, 'roomBasicInfo.maxStayCapacity', null)
      this.minStayCapacity = _.get(this.planDetail, 'roomBasicInfo.minStayCapacity', null)
      this.setLimitRoomCapacity()
      this.markOutstockDays()
    }
    this.updateSelectedDaysInfo()
    this.loadPeopleDetails(this.peopleDetails)
  },
  watch: {
    planData(val) {
      this.planDetail = _.cloneDeep(val)
      this.maxStayCapacity = _.get(this.planDetail, 'roomBasicInfo.maxStayCapacity', null)
      this.minStayCapacity = _.get(this.planDetail, 'roomBasicInfo.minStayCapacity', null)
      this.setLimitRoomCapacity()
      this.markOutstockDays()
      this.updateSelectedDaysInfo()
    },
    vacancyCalendar() {
      this.markOutstockDays()
      this.updateSelectedDaysInfo()
      if(this.vacancyCalendar?.vacancyCalendars || this.vacancyCalendar?.childPriceInfo){
        this.stateVacancyCalendars = this.vacancyCalendar.vacancyCalendars || [];
        this.stateChildInfos = this.vacancyCalendar.childPriceInfo?.childInfos || [];
      }
    },
    stayDay() {
      this.updateSelectedDaysInfo()
    },
    stayNights() {
      this.updateSelectedDaysInfo()
    },
    stayRooms() {
      // reset people
      this.updateSelectedDaysInfo()
    },
    peopleDetails(data) {
      this.loadPeopleDetails(data)
    },
    memberAdults() {
      if (this.memberAdults > 0) {
        this.checkConditionBookRoom = true
      } else {
        this.checkConditionBookRoom = false
      }
      this.triggerChange()
      this.$emit('checkConditionBookRoom', this.checkConditionBookRoom)
    },
    memberChldDetails: {
      handler() {
        this.triggerChange()
      },
      deep: true
    }
  },
  computed: {
    baseOnPrice() {
      return this.$store.getters.baseOnPrice
    },
    atPlanDetailScreen() {
      return this.source === this.SOURCE_AVAILABLE.plan_detail
    },
    atOrderConfirmationScreen() {
      return this.source === this.SOURCE_AVAILABLE.order_confirmation
    },
    userInfo() {
      return this.$store.getters['auth/get'].user
    },
    countPeopleSlot() {
      let maxSlot = +this.memberAdults
      Object.keys(this.memberChldDetails).forEach((key) => {
        if (!['childrenType30', 'childrenType50'].includes(key)) {
          maxSlot += +this.memberChldDetails[key]
        }
      })
      return maxSlot
    },
    totalMemberCnt() {
      return this.memberAdults + this.totalChldMemberCnt
    },
    totalVisitorCnt() {
      return this.visitorAdults + this.totalChldVisitorCnt
    },
    totalChldMemberCnt() {
      return Object.keys(this.memberChldDetails)
        .map((key) => this.memberChldDetails[key])
        .reduce((a, b) => a + b, 0)
    },
    totalChldVisitorCnt() {
      return Object.keys(this.visitorChldDetails)
        .map((key) => this.visitorChldDetails[key])
        .reduce((a, b) => a + b, 0)
    },
    peopleOptions() {
      const peoples = [
        {
          label: 0,
          value: 0
        }
      ]
      // const maxAdultPeople = (this.maxStayCapacity ? this.maxStayCapacity : 99) * this.limitRooms
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      const num = maxAdultPeople - (this.countPeopleSlot - this.memberAdults);
      for (let i = 0; i < num; i++) {
        peoples.push({
          label: i + 1,
          value: i + 1
        })
      }
      return peoples
    },
    maxChldSlot() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      return maxAdultPeople - (this.countPeopleSlot - this.memberAdults)
    },
    maxChldDiv10() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      return (
        maxAdultPeople - (this.countPeopleSlot - this.memberChldDetails.childrenType10)
      )
    },
    maxChldDiv15() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      return (
        maxAdultPeople - (this.countPeopleSlot - this.memberChldDetails.childrenType15)
      )
    },
    maxChldDiv20() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      return (
        maxAdultPeople - (this.countPeopleSlot - this.memberChldDetails.childrenType20)
      )
    },
    maxChldDiv30() {
      // const maxAdultPeople = (this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms)
      // return maxAdultPeople - (this.countPeopleSlot - this.memberChldDetails.childrenType30)
      return 19
    },
    maxChldDiv40() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      return (
        maxAdultPeople - (this.countPeopleSlot - this.memberChldDetails.childrenType40)
      )
    },
    maxChldDiv50() {
      // const maxAdultPeople = (this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms)
      // return maxAdultPeople - (this.countPeopleSlot - this.memberChldDetails.childrenType50)
      return 19
    },
    chldDivEnabled() {
      const childDiv = {
        memberType10: 0,
        memberType15: 0,
        memberType20: 0,
        memberType30: 0,
        memberType40: 0,
        memberType50: 0,
        visitorType10: 0,
        visitorType15: 0,
        visitorType20: 0,
        visitorType30: 0,
        visitorType40: 0,
        visitorType50: 0
      }
      if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
        // const childInfos =
        //   this.vacancyCalendar &&
        //   this.vacancyCalendar.childPriceInfo &&
        //   this.vacancyCalendar.childPriceInfo.childInfos
        //     ? this.vacancyCalendar.childPriceInfo.childInfos
        //     : []

          this.stateChildInfos.forEach((info) => {
          if (info.childDiv === '10') {
            childDiv.memberType10 += 1
          } else if (info.childDiv === '15') {
            childDiv.memberType15 += 1
          } else if (info.childDiv === '20') {
            childDiv.memberType20 += 1
          } else if (info.childDiv === '30') {
            childDiv.memberType30 += 1
          } else if (info.childDiv === '40') {
            childDiv.memberType40 += 1
          } else if (info.childDiv === '50') {
            childDiv.memberType50 += 1
          }
        })
        Object.keys(childDiv).forEach((key) => {
          if (childDiv[key] !== 0) {
            childDiv[key] = true
          } else {
            childDiv[key] = false
          }
        })
        return childDiv
      } else {
        for (let i = 0; i < this.stayNights; i++) {
          const checkDay = this.getDataMoment(this.stayDay).add(i, 'days')
          if (this.stateVacancyCalendars) {
            const checkVacancy = _.get(
              this.stateVacancyCalendars.filter((v) =>
                moment(v.stayDay).isSame(checkDay, 'day')
              ),
              '[0]',
              null
            )
            if (checkVacancy) {
              const childrenPriceTable = checkVacancy.childrenPriceTable || []
              childrenPriceTable.forEach((chldTable) => {
                if (chldTable.childDiv === '10' && chldTable.price !== null) {
                  childDiv.memberType10 += 1
                } else if (chldTable.childDiv === '15' && chldTable.price !== null) {
                  childDiv.memberType15 += 1
                } else if (chldTable.childDiv === '20' && chldTable.price !== null) {
                  childDiv.memberType20 += 1
                } else if (chldTable.childDiv === '30' && chldTable.price !== null) {
                  childDiv.memberType30 += 1
                } else if (chldTable.childDiv === '40' && chldTable.price !== null) {
                  childDiv.memberType40 += 1
                } else if (chldTable.childDiv === '50' && chldTable.price !== null) {
                  childDiv.memberType50 += 1
                }

                if (chldTable.childDiv === '10' && chldTable.childPrice !== null) {
                  childDiv.visitorType10 += 1
                } else if (chldTable.childDiv === '15' && chldTable.childPrice !== null) {
                  childDiv.visitorType15 += 1
                } else if (chldTable.childDiv === '20' && chldTable.childPrice !== null) {
                  childDiv.visitorType20 += 1
                } else if (chldTable.childDiv === '30' && chldTable.childPrice !== null) {
                  childDiv.visitorType30 += 1
                } else if (chldTable.childDiv === '40' && chldTable.childPrice !== null) {
                  childDiv.visitorType40 += 1
                } else if (chldTable.childDiv === '50' && chldTable.childPrice !== null) {
                  childDiv.visitorType50 += 1
                }
              })
            }
          }
        }
        Object.keys(childDiv).forEach((key) => {
          if (childDiv[key] === +this.stayNights) {
            childDiv[key] = true
          } else {
            childDiv[key] = false
          }
        })
        return childDiv
      }
    }
  },
  methods: {
    loadPeopleDetails(data) {
      if (!data) {
        return
      }
      const peopleDetails = _.cloneDeep(data)
      if (
        peopleDetails.memberAdults !== undefined &&
        peopleDetails.memberAdults !== null
      ) {
        this.memberAdults = peopleDetails.memberAdults
      }
      if (
        peopleDetails.visitorAdults !== undefined &&
        peopleDetails.visitorAdults !== null
      ) {
        this.visitorAdults = peopleDetails.visitorAdults
      }
      if (!_.isEmpty(peopleDetails.memberChldDetails)) {
        this.memberChldDetails = peopleDetails.memberChldDetails
      }
      if (!_.isEmpty(peopleDetails.visitorChldDetails)) {
        this.visitorChldDetails = peopleDetails.visitorChldDetails
      }
    },
    setLimitRoomCapacity() {
      if (_.get(this.planDetail, 'menuInformation.extSystemCd') === 'RakutenT') {
        this.limitRooms = 10
      } else if (_.get(this.planDetail, 'menuInformation.extSystemCd') === 'ToyokoInn') {
        this.limitRooms = 4
      } else {
        this.limitRooms = 19
      }
      this.limitPeoples = 19
    },
    getSelectedDays() {
      if (this.stayDay) {
        const stayDay = moment(this.stayDay).format(this.dateFormat)
        const selectedDays = [stayDay]
        for (let i = 1; i <= this.stayNights; i++) {
          selectedDays.push(moment(stayDay).add(i, 'days').format(this.dateFormat))
        }
        return selectedDays
      }
      return []
    },
    validatePeople() {
      // CHECK DAY SELECTED IS INSTOCK
      let hasOutStockDay = false
      for (let i = 0; i < this.stayNights; i++) {
        const checkDay = moment(this.stayDay).add(i, 'days')
        if (this.isOutstockDay(checkDay)) {
          hasOutStockDay = true
        }
      }
      if (hasOutStockDay) {
        this.$toasted.error('空室がない日付を選択しました。')
        // this.$toasted.error('空室がない日付を選択しました。')
        return false
      }
      // Số phòng còn lại của khách hàng
      const minStayStock = this.getMinRoomStock(this.selectedDaysInfo)
      if (minStayStock !== null && this.stayRooms > minStayStock) {
        this.$toasted.error('選択された部屋の数が、空室な部屋の数を超えました。')
        // this.$toasted.error('利用可能な部屋の数を超えた人数')
        return false
      }
      // Mỗi phòng cần ít nhất 1 người dùng chăn: minStayCapacity
      if (this.stayRooms > this.totalMemberCnt + this.totalVisitorCnt) {
        this.$toasted.error('選択された人数は、1部屋あたり最低1人に達していません。')
        return false
      }
      // Vượt quá số người 1 phòng: maxStayCapacity
      if (
        this.totalMemberCnt + this.totalVisitorCnt >
        this.stayRooms * this.maxStayCapacity
      ) {
        this.$toasted.error('選択された人数が最大数を超えました。')
        return false
      }
      return true
    },
    isOutstockDay(date) {
      if (date && this.outstockDayMap[date.format(this.dateFormat)]) {
        return true
      }
      return false
    },
    markOutstockDays() {
      this.outstockDayMap = {}
      const lastDay = moment(this.stayDay).endOf('month').date()
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      const inStockDays = vacancyCalendars.map((e) => e.stayDay)
      // const closeDays = []
      for (let i = 1; i <= lastDay; i++) {
        const month =
          moment(this.stayDay).month() + 1 > 9
            ? moment(this.stayDay).month() + 1
            : `0${moment(this.stayDay).month() + 1}`
        const day = `${moment(this.stayDay).year()}/${month}/${i > 9 ? i : `0${i}`}`
        if (!inStockDays.includes(day)) {
          this.outstockDayMap[day] = true
          // closeDays.push(day)
        }
      }
      // return closeDays
    },
    updateSelectedDaysInfo() {
      const selectedDaysTemp = []
      const selectedDays = _.cloneDeep(this.getSelectedDays())
      if (selectedDays.length > 0) {
        selectedDays.splice(-1)
      }
      const vacancyCalendars =
        this.vacancyCalendar && this.vacancyCalendar.vacancyCalendars
          ? this.vacancyCalendar.vacancyCalendars
          : []
      // let netAmount = 0

      selectedDays.forEach((day) => {
        const dayInfo = {
          stayDay: day,
          childTypePrice: {},
          roomPrice: null,
          price: null,
          adultPrice: null,
          boneSubsidy: null,
          stock: null,
          reservationDiv: null,
          childrenPriceTable: []
        }
        vacancyCalendars.forEach((vacancy) => {
          if (moment(day).isSame(moment(vacancy.stayDay))) {
            // const memberPrice = vacancy.price ? vacancy.price : 0
            const roomPrice = vacancy.roomPrice ? vacancy.roomPrice : 0
            // netAmount += ((this.stayAdults * memberPrice) + (this.stayRooms * roomPrice))
            dayInfo['childTypePrice'] = {}
            if (!roomPrice) {
              dayInfo['childTypePrice']['childrenType10'] = this.getMemberChildPrice(
                'a',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType15'] = this.getMemberChildPrice(
                'b',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType20'] = this.getMemberChildPrice(
                'c',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType30'] = this.getMemberChildPrice(
                'd',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType40'] = this.getMemberChildPrice(
                'e',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['childrenType50'] = this.getMemberChildPrice(
                'f',
                vacancy.childrenPriceTable
              )

              dayInfo['childTypePrice']['visitorType10'] = this.getVisitorChildPrice(
                'a',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType15'] = this.getVisitorChildPrice(
                'b',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType20'] = this.getVisitorChildPrice(
                'c',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType30'] = this.getVisitorChildPrice(
                'd',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType40'] = this.getVisitorChildPrice(
                'e',
                vacancy.childrenPriceTable
              )
              dayInfo['childTypePrice']['visitorType50'] = this.getVisitorChildPrice(
                'f',
                vacancy.childrenPriceTable
              )
              // Object.keys(this.memberChldDetails).forEach(key => {
              //   if (this.memberChldDetails[key]) {
              //     netAmount += (this.memberChldDetails[key] * this.getMemberChildPrice(key, vacancy.childrenPriceTable) * this.stayRooms)
              //   }
              // })
            }
            dayInfo.adultPrice = vacancy.adultPrice
            dayInfo.boneSubsidy = vacancy.boneSubsidy
            dayInfo.price = vacancy.price
            dayInfo.roomPrice = vacancy.roomPrice
            dayInfo.stock = vacancy.stock
            dayInfo.reservationDiv = vacancy.reservationDiv
            dayInfo.childrenPriceTable = vacancy.childrenPriceTable
          }
        })
        selectedDaysTemp.push(dayInfo)
      })
      this.selectedDaysInfo = selectedDaysTemp
    },
    triggerChange() {
      this.$emit('change', {
        totalPeopleCnt: this.totalMemberCnt + this.totalVisitorCnt,
        memberAdults: this.memberAdults,
        memberChildrenCnt: this.totalChldMemberCnt,
        visitorAdults: this.visitorAdults,
        visitorChildrenCnt: this.totalChldVisitorCnt,
        memberChldDetails: this.memberChldDetails,
        visitorChldDetails: this.visitorChldDetails
      })
    },
    adultDecrement() {
      let adults = Number(this.memberAdults);
      if (adults > 0) {
        this.memberAdults = adults - 1;
      }
    },
    adultIncrement() {
      let adults = Number(this.memberAdults);
      let maxAdults = Number(this.peopleOptions.length || 0) ;
      if (adults < maxAdults ) {
        this.memberAdults = adults + 1;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
